import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { PaperClipIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import React from 'react'

const FilesCell = ({ row }) => {
  const count = row.fileCount || 0
  const files = row.files || []

  if (count === 0) {
    return <span className="text-charcoal-300 text-sm">—</span>
  }

  return (
    <Popover className="relative">
      <PopoverButton
        className="hover:text-blue-dark flex items-center gap-1 text-blue-800 focus:outline-none"
        onClick={(e) => e.stopPropagation()}
        title={`${count} file${count > 1 ? 's' : ''}`}
      >
        <PaperClipIcon className="h-4 w-4" />
        <span className="text-xs font-medium">{count}</span>
      </PopoverButton>
      {files.length > 0 && (
        <PopoverPanel
          anchor={{ to: 'bottom start', gap: 4 }}
          className="z-20 min-w-[200px] rounded-lg border border-gray-200 bg-white p-2 shadow-lg focus:outline-none"
        >
          {files.map((f) => (
            <a
              key={f.id}
              href={f.file}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:bg-charcoal-50 flex items-center gap-2 rounded px-2 py-1.5 text-sm text-blue-800"
              onClick={(e) => e.stopPropagation()}
            >
              <PaperClipIcon className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{f.displayName || 'File'}</span>
            </a>
          ))}
        </PopoverPanel>
      )}
    </Popover>
  )
}

FilesCell.propTypes = {
  row: PropTypes.object.isRequired,
}

export default FilesCell
